import { useEffect } from 'react';

import { BoardHeader } from '../boards/components/BoardHeaders';
import { AgileEpics } from './components/agile/Epics';
import { AgileSprints } from './components/agile/Sprints';
import { Analytics } from './components/board/Analytics';
import { Kanban as Board } from './components/board/Kanban';
import { useAgileStore } from './store';

const views = {
  sprints: <AgileSprints />,
  epics: <AgileEpics />,
  board: <Board />,
  analytics: <Analytics />,
};

export const Scrum = () => {
  const { selectedView, boardId, clearStore } = useAgileStore();
  useEffect(() => {
    return clearStore;
  }, []);

  return (
    <>
      <div className="bg-gray-100 min-h-screen">
        <BoardHeader type="agile" boardId={boardId} isScrum />
        {views[selectedView]}
      </div>
    </>
  );
};
